import { httpWrapper } from 'services/http';
import userService from 'services/user';
import { endpointCorporateClient } from '.';
import { API_URL_REPORTS_V1 } from 'constants.js';

export const getSalesforceInvoicesList = async payload => {
  const authHeaders = await userService.getAuthorizationHeaders();
  const requestOptions = {
    method: 'GET',
    url: `${endpointCorporateClient('/invoices/salesforce', true, API_URL_REPORTS_V1)}?startDate=${
      payload?.startDate
    }&endDate=${payload?.endDate}`,
    headers: {
      ...authHeaders,
    },
  };

  const response = httpWrapper(requestOptions);
  return response;
};

export const getSalesforceInvoiceDocument = async invoiceId => {
  const authHeaders = await userService.getAuthorizationHeaders();
  const requestOptions = {
    method: 'GET',
    url: `${endpointCorporateClient(
      `/invoices/salesforce/${invoiceId}`,
      true,
      API_URL_REPORTS_V1,
    )}`,
    headers: {
      ...authHeaders,
    },
    responseType: 'arraybuffer',
  };

  const response = httpWrapper(requestOptions);
  return response;
};
